/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { decodeColor } from 'betterplace-utils'
import { AmountCSSProperties } from './Amount'
import { CommentCSSProperties } from './Comment'
import type { Maybe, Pretty } from '@/types'
import classNames from 'classnames'

export function parseBooleanString(boolStr?: string) {
  return boolStr === 'true' ? true : false
}

export function composeSelectedFontObject(font?: string, weight?: number) {
  const defaultFont = 'Fira Sans'
  const defaultWeight = 400
  return {
    family: font ?? defaultFont,
    weights: [weight ?? defaultWeight],
  }
}

type MergeTypes<A, B> = Pretty<
  {
    [K in keyof A & keyof B]: undefined extends A[K]
      ? undefined extends B[K]
        ? A[K]
        : B[K] extends A[K]
          ? Exclude<A[K], undefined>
          : never
      : A[K]
  } & {
    [K in Exclude<keyof A, keyof B>]: A[K]
  } & {
    [K in Exclude<keyof B, keyof A>]: B[K]
  }
>

export function buildInitialValues<T extends {}>(defaults: T) {
  return <R extends Maybe<Partial<{}>>>(
    values?: R
  ): R extends null | undefined ? T : R extends Partial<infer V> ? MergeTypes<V, T> : never => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    if (!values) return defaults as any
    const result = { ...defaults, ...values } as any
    for (const key in values) {
      if (result[key] === undefined) {
        result[key] = defaults[key as unknown as keyof T]
        continue
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return result
  }
}

export function getClusterStyles(isCluster: boolean, textAlign: 'left' | 'center' | 'right') {
  if (!isCluster) return
  return classNames('cluster', {
    'cluster-left': textAlign === 'left',
    'cluster-center': textAlign === 'center',
    'cluster-right': textAlign === 'right',
  })
}
export function getDataCssVariables(
  dataFont: string,
  dataFontSize: number,
  dataFontWeight: number,
  dataFontColor: string
): AmountCSSProperties {
  return {
    '--streambot-data-font': dataFont,
    '--streambot-data-font-size': `${dataFontSize}px`,
    '--streambot-data-font-weight': dataFontWeight.toString(),
    '--streambot-data-font-color': decodeColor(dataFontColor),
  } as AmountCSSProperties
}

export function getCommentCssVariables(
  commentFont: string,
  commentFontSize: number,
  commentFontWeight: number,
  commentFontColor: string
): CommentCSSProperties {
  return {
    '--streambot-comment-font': commentFont,
    '--streambot-comment-font-size': `${commentFontSize}px`,
    '--streambot-comment-font-weight': commentFontWeight.toString(),
    '--streambot-comment-font-color': decodeColor(commentFontColor),
  } as CommentCSSProperties
}
